export const currentPattern = /^[A-Z]{2}\d{2}[A-Z]{3}$/;
export const prefixPattern = /^[A-Z]\d{1,3}[A-Z]{3}$/;
export const suffixPattern = /^[A-Z]{3}\d{1,3}[A-Z]$/;
export const datelessPattern = /^(?:[A-Z]{1,3}\d{1,4}|\d{1,4}[A-Z]{1,3})$/;

const privatePattern = /^[A-Z]{1,3}\d{1,3}[A-Z]{1,3}$/;

export function normalizeUkReg(input = "") {
  if (input == null) return "";
  return String(input).toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 8);
}

export function isValidUkReg(input) {
  const registration = normalizeUkReg(input);
  if (registration.length < 2 || registration.length > 8) return false;
  return currentPattern.test(registration)
    || prefixPattern.test(registration)
    || suffixPattern.test(registration)
    || datelessPattern.test(registration)
    || privatePattern.test(registration);
}

export function formatUkReg(input) {
  const registration = normalizeUkReg(input);
  if (currentPattern.test(registration)) return `${registration.slice(0, 4)} ${registration.slice(4)}`;
  if (prefixPattern.test(registration)) return `${registration.slice(0, -3)} ${registration.slice(-3)}`;
  if (suffixPattern.test(registration)) return `${registration.slice(0, 3)} ${registration.slice(3)}`;
  return registration;
}

// Browser copies of isValidUkReg and formatUkReg for inline scripts on
// server-rendered pages, built from the same patterns.
export const VALID_REG_INLINE_FN = `function validReg(r){return r.length>=2&&r.length<=8&&(${[currentPattern, prefixPattern, suffixPattern, datelessPattern, privatePattern].map((p) => `${p}.test(r)`).join("||")});}`;
export const FORMAT_REG_INLINE_FN = `function fmt(r){r=String(r||"").toUpperCase().replace(/[^A-Z0-9]/g,"");if(${currentPattern}.test(r))return r.slice(0,4)+" "+r.slice(4);if(${prefixPattern}.test(r))return r.slice(0,-3)+" "+r.slice(-3);if(${suffixPattern}.test(r))return r.slice(0,3)+" "+r.slice(3);return r;}`;
